module.exports = __webpack_public_path__ + "static/media/checkvertical.00353efb.jpg";